<template>
  <div id="analytics-kabayan-page">
    <page-header-component
      v-if="topics"
      :topics="topics"
      @pageHeaderLoaded="pageHeaderLoaded"
      title="Analytics"
      class="m-b-10"
    />
    <tab-medsos-component v-if="show_body" />
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import tab_medsos from "@/views/components/analytics/general/tab_medsos.vue";

export default {
  name: "AnalyticsKabayan",
  components: {
    "page-header-component": page_header,
    "tab-medsos-component": tab_medsos,
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      topics: null,
      show_body: false,
    };
  },
  methods: {
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.topics = response.data;
        } else {
          this.topics = {};
        }
      });
    },
    pageHeaderLoaded: function () {
      this.show_body = true;
    },
  },
  created: function () {
    this.getTopic();
  },
};
</script>